import { definePlatformAPI, } from '../../common';
export const platformAPICreator = definePlatformAPI((superAPI) => {
    return () => {
        return {
            editor: {
                accessibility: {
                    getAdvancedSettings: () => superAPI.accessibility.getAdvancedSettings(),
                    setAdvancedSettings: (_appData, _token, options) => superAPI.accessibility.setAdvancedSettings(options.value),
                },
            },
            document: {
                accessibility: {
                    getSkipToContent: () => superAPI.accessibility.getSkipToContent(),
                    setSkipToContent: (appData, _token, options) => superAPI.accessibility.setSkipToContent(appData.appDefinitionId, options),
                    getVisualFocus: () => superAPI.accessibility.getVisualFocus(),
                    setVisualFocus: (appData, _token, options) => superAPI.accessibility.setVisualFocus(appData.appDefinitionId, options),
                    getAutoDomReorder: () => superAPI.accessibility.getAutoDomReorder(),
                    setAutoDomReorder: (appData, _token, options) => superAPI.accessibility.setAutoDomReorder(appData.appDefinitionId, options),
                },
            },
        };
    };
});
//# sourceMappingURL=accessibility.internal.v1.js.map